const VENUE_INFO = {
    WSC: { name: "Whitechapel", courts: 4, slotDurations: [40, 60] },
    JOSC: { name: "John Orwell", courts: 4, slotDurations: [40, 60] },
    PBLC: { name: "Poplar Baths", courts: 4, slotDurations: [40, 60] },
    MEPLS: { name: "Mile End", courts: 4, slotDurations: [40, 60] },
    "UEL-SPORT-DOCK": { name: "UEL", courts: 2, slotDurations: [60] },
};
const DEFAULT_COURT_COUNT = 4;
const DEFAULT_SLOT_DURATIONS = [40, 60];
export function venueShortName(id) {
    if (!id)
        return "";
    const key = id.toUpperCase();
    return VENUE_INFO[key]?.name ?? key;
}
export function venueCourtCount(id, fallback = DEFAULT_COURT_COUNT) {
    if (!id)
        return fallback;
    const key = id.toUpperCase();
    return VENUE_INFO[key]?.courts ?? fallback;
}
export function venueSlotDurations(id) {
    if (!id)
        return DEFAULT_SLOT_DURATIONS;
    const key = id.toUpperCase();
    return VENUE_INFO[key]?.slotDurations ?? DEFAULT_SLOT_DURATIONS;
}
export function venueShortNames(ids) {
    if (ids.length === 0)
        return "";
    const seen = new Set();
    const out = [];
    for (const id of ids) {
        const key = id.toUpperCase();
        if (seen.has(key))
            continue;
        seen.add(key);
        out.push(venueShortName(id));
    }
    return out.join(", ");
}
/**
 * Deterministic display colour for a venue — hand-picked for the known venues
 * (stable + distinct), FNV-1a hash into a palette for anything else. Used to
 * colour-code venues consistently with credentials.
 */
const VENUE_COLORS = {
    JOSC: "#059669", // emerald
    WSC: "#0891B2", // cyan
    PBLC: "#D97706", // amber
    MEPLS: "#8B5CF6", // purple
    "UEL-SPORT-DOCK": "#E11D48", // rose
};
const VENUE_FALLBACK_PALETTE = [
    "#0D9488",
    "#6366F1",
    "#DC2626",
    "#16A34A",
    "#9333EA",
    "#0891B2",
];
export function venueColor(id) {
    if (!id)
        return "#64748B";
    const key = id.toUpperCase();
    const known = VENUE_COLORS[key];
    if (known)
        return known;
    let hash = 2166136261;
    for (let i = 0; i < key.length; i++) {
        hash ^= key.charCodeAt(i);
        hash = Math.imul(hash, 16777619);
    }
    return VENUE_FALLBACK_PALETTE[Math.abs(hash) % VENUE_FALLBACK_PALETTE.length];
}
